const k = require('./keys');
export default {
  [k._DOT]: '.',
  [k.HELLO]: 'こんにちは ',
  [k.ENTER_NEW_PASSWORD]: '新しいパスワードをここに入力する。自動的にログインされ、リダイレクトされる。',
  [k.UNSUBSCRIBED_SUCCESSFULLY]:
    'あなたは当社のメールリストから正常に削除されました。これからは、結婚式に直接関連するメールのみを受け取ります。結婚式のすべての情報をプラットフォームから削除したい場合は、メールでご連絡ください。',
  [k.VOUCHER_USED_SUCCESSFULLY]: 'クーポンが正常に入力されました。割引を利用するために支払い手続きを開始してください。',
  [k.MINIMUM_6_CHARACTERS]: '6文字以上で入力してね。',
  [k.SAVE]: '保存する',
  [k.UNABLE_TO_RESET_PASSWORD]: 'パスワードをリセットできなかった。',
  [k.PASSWORD_CHANGED_SUCCESSFULLY_TITLE]: 'パスワードの変更に成功した',
  [k.PASSWORD_CHANGED_SUCCESSFULLY]: 'パスワードを変更した！新しいパスワードでログインできる。転送する',
  [k.FUNCTIONS]: '特徴',
  [k.DESIGNS]: 'テーマ',
  [k.PRICES]: '価格',
  [k.FAQ]: 'よくある質問',
  [k.BLOG]: 'ブログ',
  [k.CREATE_NOW_FREE]: '今すぐ無料で作成する',
  [k.PERFECT_PAGE_FOR_YOU]: 'あなただけのウェブサイトを！',
  [k.PERFECT_DESIGN_IN_FEW_CLICKS]: 'デザインコンフィギュレーターを使えば、わずか数クリックで完璧なデザインを実現。',
  [k.DESIGN]: 'デザイン',
  [k.HOW_DESCRIBE_YOUR_DREAM_WEDDING]: '理想のウェディングは？',
  [k.CLICK_ON_ONE_OF_THE_IMAGES]: 'デザインコンフィギュレーターを開始するには、画像のいずれかをクリックする',
  [k.CREATE_WEDDING_WEBSITE_NOW]: '今すぐ無料で作成する',
  [k.FREQUENTLY_ASKED_QUESTIONS]: 'よくあるご質問',
  [k.ANY_MORE_QUESTIONS_OR_FEEDBACK]: 'ご質問やご意見はある？',
  [k.WE_LOOK_FORWARD_TO_IT]: 'ご連絡をお待ちしております！',
  [k.CONTENT_AND_DESIGN]: 'コンテンツ＆デザイン',
  [k.PHOTO_GALLERY]: 'フォトギャラリー',
  [k.RSVP_CARD]: 'RSVP/返信カード',
  [k.PLAYLIST]: 'プレイリスト',
  [k.MULTILINGUAL_OWN_DOMAIN]: '多言語＆独自ドメイン',
  [k.DURATION_PASSWORD_PROTECTION]: 'ランタイム＆パスワード保護',
  [k.COST_SUPPORT]: '費用とサポート',
  [k.WHAT_CONTENT_TYPICALLY]: 'ウエディング・サイトの典型的なコンテンツは？',
  [k.CAN_CREATE_WEBSITE_BEFORE_DETAILS]:
    'すべての詳細（結婚式の日付など）が確定する前に結婚式のWebページを作成することはできますか？',
  [k.CAN_CUSTOMIZE_DESIGN]: '私は私の結婚式のウェブサイトのデザインをカスタマイズすることはできる？',
  [k.CHANGES_VISIBLE_AFTER_SAVE]: 'ホームページの変更は、すぐにみんなに見られることなくできるのか？',
  [k.PHOTO_UPLOAD_LIMIT]: 'ギャラリーにアップロードできる写真の枚数に制限はある？',
  [k.ORIGINAL_SIZE_PHOTO_STORAGE]: '写真はオリジナルサイズで保存されるのか？',
  [k.GUESTS_DOWNLOAD_UPLOADED_PHOTOS]: 'ゲストはサイトにアップロードした写真をダウンロードできるのか？',
  [k.USE_PHOTO_GALLERY_FOR_SLIDESHOW]: 'パーティー中にフォトギャラリーをライブスライドショーに使うことはできる？',
  [k.HOW_DOES_R_S_V_P_WORK]: 'RSVP機能はどのように機能するのか？',
  [k.GUESTS_ADD_OWN_SONGS_TO_PLAYLIST]: 'ゲストはプレイリストに自分の曲を追加できる？',
  [k.CAN_DJ_ACCESS_PLAYLIST]: 'DJはプレイリストにアクセスできる？',
  [k.POSSIBILITY_OF_MULTIPLE_LANGUAGES]: 'ホームページを異なる言語で表示することは可能？',
  [k.OWN_DOMAIN_POSSIBILITY]: 'ウエディングサイト用の独自ドメインは取得できる？',
  [k.HOW_LONG_ACCESS_WEDDING_WEBSITE]: '私たちの結婚式のウェブサイトはどのくらいの期間利用できるようになる？',
  [k.PROTECT_SITE_WITH_PASSWORD]: '私達は私達の場所をパスワードで保護してもいいか。',
  [k.IS_EUREHOCHZEITONLINE_FREE]: 'EureHochzeitOnline.comは無料で使用できるか？',
  [k.HOW_GET_SUPPORT_EUREHOCHZEITONLINE]:
    'EureHochzeitOnline.comで結婚式のホームページを作成する場合、どのようなサポートがあるのか？',
  [k.WEDDING_CONTENT_INDIVIDUAL]:
    'あなたの結婚式のホームページの内容は、あなたの結婚式そのものと同じくらい個人的なものである。日付や場所などの基本的な情報に加えて、ドレスコード、道順、特別なリクエスト、司式者の連絡先、または計画されたタイムラインを追加することができる。遠方から来るゲストのために、宿泊施設をリストアップすることもできる。また、ゲストとラブストーリーを共有したり、パートナーについての個人的な言葉を書いたりするのもいいアイデアだ。あなたの創造性に限界はない。',
  [k.YES_FEASIBLE_ADVANTAGES]:
    'そう、これは簡単で、大きなメリットさえある。結婚式の招待状が送られた後でも、いつでも情報を追加し、最新情報を提供することができる。',
  [k.YES_EUREHOCHZEITONLINE_OFFERS]:
    'そう、EureHochzeitOnline.comは、あなたの結婚式のウェブサイトのための様々なデザインオプションを提供している。あなたは色、フォント、および追加の要素をカスタマイズすることができる。ご質問やご意見があればご連絡を。',
  [k.INDEED_CHANGES_VISIBLE]:
    '実際、あなたのウェブサイトへのすべての変更はすぐにリアルタイムですべての訪問者に表示される。現在のところ、事前に変更をスケジュールしたり、非表示にしたりする機能は提供していない。',
  [k.IN_FREE_VERSION_LIMITED_PHOTOS]:
    '無料版ではギャラリーにアップロードできる写真の枚数に制限がある。これは、ストレージとトラフィックに関連するコストが発生するためである。しかし、プレミアムまたはドメインパッケージを購入すれば、ギャラリーにアップロードできる写真の枚数は無制限になる。完璧なウェディングフォトを手に入れるためのヒントはブログをチェック。',
  [k.WE_GENERATE_DIFFERENT_SIZES]:
    'あなたが写真をアップロードするとき、私たちはそれぞれの画像に異なるサイズを作成する。訪問者の画面サイズに応じて、最適なサイズが自動的に選択され、可能な限り最高の画質で高速な読み込み時間を保証する。しかし、我々はまた、あなたが同様にそれらを受け取ることができるように、写真のオリジナルファイルを保存する。',
  [k.YES_GUESTS_CAN_DOWNLOAD]: 'はい、ゲストはアップロードされた写真をダウンロードできる。',
  [k.YES_FEASIBLE_SCREEN_PROJECTOR]:
    'もちろん！実際、これはEureHochzeitOnlineの最も人気のある機能の一つである。必要なのは安定したインターネット接続と、もちろんスクリーンかプロジェクターだけだ。',
  [k.R_S_V_P_FUNCTION_SIMPLIFIES]:
    'RSVP機能は、あなたの結婚式のウェブサイトのログイン情報をゲストと簡単に共有することができる。ゲストがあなたのウェディングサイトにアクセスしたら、フィードバック（何人で参加するか、子供か大人か、特別な料理リクエスト、アレルギー、その他の要望など）を残すよう求められる。ゲストエリアでは、いつでも受諾数とキャンセル数を追跡することができる。ステップ・バイ・ステップの手順はブログを参照のこと。',
  [k.YES_YOUR_GUESTS_CAN_SUGGEST]:
    'もちろん！ゲストが好きな曲を提案し、プレイリストに追加できる。だから、ゲストの多様性を祝うことができるだけでなく、あなたやあなたの大切な人たちにとって大切な音楽を楽しむこともできる。',
  [k.NATURALLY_INVITE_DJ_TO_WEBSITE]:
    'もちろんだ。あなたのウェブサイトにDJを招待するだけで、あなたの希望はすべてDJの自由になる。',
  [k.YES_YOU_CAN_HAVE_MULTIPLE_LANGUAGES]:
    'そう、あなたのウェブサイトを多言語にすることもできる。この機能はプレミアムパッケージで利用可能で、すべての情報を異なる言語に翻訳することができる。あなたの結婚式に合わせた設定をさせていただくので、ご連絡を。',
  [k.YES_YOU_CAN_HAVE_OWN_DOMAIN]:
    'はい、プレミアムパッケージでは、ウェディングウェブサイト用の独自ドメイン（例：www.juliaundromeo.de）を簡単に予約することができる。ドメインの予約とリダイレクトの設定をいたしますので、ご連絡ください。',
  [k.YOUR_WEDDING_WEBSITE_AVAILABLE_TWO_YEARS]:
    'あなたのウェディングウェブサイトは、作成後2年間利用できる。その後、新しいウェディングウェブサイトのためのスペースを作るために削除される。事前にお知らせする。更新はご要望に応じて可能である。',
  [k.ALL_WEDDING_WEBSITES_PASSWORD_PROTECTED]:
    'すべてのウェディング・ホームページはパスワードで保護されており、作成後にパスワードが表示される。',
  [k.YES_CREATE_WEDDING_WEBSITE_FREE]:
    'はい、あなたは無料でEureHochzeitOnline.comで結婚式のウェブサイトを作成し、設計することができる。しかし、いくつかの高度な機能は無料ではない、特に追加のサーバーリソースを必要とするものである。隠された料金はない。',
  [k.IF_YOU_NEED_SUPPORT_WE_CAN_HELP]:
    'あなたの結婚式のウェブサイトを作成するヘルプが必要な場合は、お気軽にbeeni@eurehochzeitonline.com。我々はあなたを支援するためにできるだけ早くあなたに戻って取得する。',
  [k.KEY_FEATURES_OVERVIEW]: '一目でトップ機能！',
  [k.YOUR_WEDDING_WEBSITE_OFFERS_EVERYTHING]:
    'あなたの夢の結婚式を作成するために必要なすべてがあなたの結婚式のウェブサイトはここにある。',
  [k.NEW_NOW]: '新しい：',
  [k.MULTILINGUAL_WEDDINGS]: '多言語ウェディング！',
  [k.ON_REQUEST_WE_PROVIDE_WEDDING_WEBSITES]: '新機能：多言語ウェブサイトが利用可能！',
  [k.SCHEDULE]: 'ウェディングタイムライン',
  [k.LOCATIONS]: '結婚式の場所',
  [k.RSVP]: '返信カード',
  [k.GUESTMANAGEMENT]: 'ゲスト管理',
  [k.HOTEL_RECOMMENDATION]: 'ホテルの推薦',
  [k.PRESENT_TABLE]: 'ギフトテーブル',
  [k.OWN_DOMAIN]: 'カスタムドメイン',
  [k.DIVERSE_LAYOUTS]: '数え切れないほどのレイアウトやデザインから選び、カスタマイズできる。',
  [k.YOUR_WEDDING_DAY]: '結婚式の一日をゲストのためにきちんと整理する。',
  [k.CLEAR_DIRECTIONS]: '結婚式のすべての場所へのわかりやすい案内。',
  [k.NO_GUESSWORK]: '誰が結婚式に来るのか、面倒な問い合わせはもういらない。',
  [k.GUEST_ADDRESSES_ALLERGIES]: '住所、アレルギーなどをワンクリックで収集！',
  [k.HOTEL_SELECTION_FOR_GUESTS]: 'ゲストのためのホテル選択！',
  [k.EASY_ONLINE_GIFT_REGISTRY]: '結婚登録が簡単にできる',
  [k.WEDDING_PICTURES_FOR_GUESTS]: 'お二人の結婚式の写真とゲストの写真を一ヶ所に。',
  [k.CUSTOM_SPOTIFY_PLAYLIST_CREATION]: 'お二人だけのSpotifyプレイリスト-お二人とゲストが作成。',
  [k.WEDDING_HOMEPAGE_WITH_OWN_DOMAIN]: 'お二人だけのドメインとパスワードで保護されたウェディングウェブサイト。',
  [k.YOUR_WEDDING_WEBSITE]: 'お二人だけのウェディングサイト',
  [k.UNIQUE_LIKE_YOU]: '- おふたりだけのオリジナル！',
  [k.EASY_SETUP_CUSTOMIZED]: 'セットアップとカスタマイズが簡単！',
  [k.ALL_DETAILS_OF_YOUR_CELEBRATION]: 'スマホでもPCでも、イベントの詳細が一目でわかる',
  [k.GUEST_FEEDBACK_AND_WISHES]: 'ゲストの確認やリクエストも一目瞭然',
  [k.YOUR_CELEBRATION_FROM_ALL_VIEWS]:
    'あらゆる角度からあなたのパーティーを見ることができる-あなたとゲストのためのライブ写真ギャラリー',
  [k.MULTILINGUAL_SUPPORT]: '...もちろん多言語ウェディングにも対応',
  [k.FREE_CREATE]: '今すぐ無料で作成する',
  [k.DEMO_WEBSITE]: 'デモウェブサイト',
  [k.OUR_PRICING]: '価格',
  [k.UNLOCK_ALL_FEATURES]: '一回限りの料金ですべての機能を利用できる',
  [k.ANY_QUESTIONS_OR_FEEDBACK]: 'ご質問やご要望は？',
  [k.WE_ARE_HERE_TO_HELP]: 'ご連絡をお待ちしております！',
  [k.USER_TESTIMONIALS]: 'ユーザーの声',
  [k.THOUSANDS_OF_PEOPLE]: '何千人もの人々がすでにEureHochzeitOnlineで結婚式を祝っている！',
  [k.OUR_GIFT_TIP]: 'ギフトのアイデア',
  [k.FOR_ALL_WITNESSES]: '',
  [k.BUY_WEDDING_WEBSITE_AS_GIFT]: '新郎新婦にパーソナライズされた結婚式のウェブサイトをプレゼントしよう！',
  [k.BRIDE]: '新婦',
  [k.F_WITNESS]: 'メイド・オブ・オナー',
  [k.GROOM]: '新郎',
  [k.TESTIMONIAL_1]:
    'ウェブサイトを作るのは簡単だった。複雑な情報も簡単に追加できて、本当に驚いた。本当に自分たちのウェブサイトを作ることができた。ゲストも感動してくれた！',
  [k.TESTIMONIAL_2]:
    'ゲスト全員が母国語でサイトを利用できるのが素晴らしかった。自分の好きな曲を提案できるプレイリスト機能も気に入ってくれた。こうして、パーティーの音楽を通して、ゲストの多様性も祝福された。',
  [k.TESTIMONIAL_3]:
    '私たちのウェブサイトは、結婚式の準備期間中、非常に役に立った。重要な情報をいつでも更新でき、美しいフォトギャラリーで写真を紹介することもできた。ゲストはライブスライドショーを気に入ってくれたし、私たちはもっと気に入っていた。',
  [k.TESTIMONIAL_4]:
    '1年以上経った今でも、結婚式のSpotifyプレイリストを聴いて楽しんでいる。私たちの結婚式のウェブサイトのおかげで、素晴らしい思い出のある結婚式を挙げることができた。',
  [k.THANK_YOU]: 'ありがとうございました！',
  [k.ACTIVATED_MAIL]: 'メールアドレスを有効にした！',
  [k.CLICK_HERE_TO_GO_TO_WED]: 'ここをクリックして',
  [k.AND]: 'そして',
  [k.BE_REDIRECTED]: 'にリダイレクトされる。',
  [k.SET_A_PASSWORD]: 'あなたが常にログインし、あなたの結婚式を編集できるようにパスワードを設定してください！',
  [k.SET_A_PASSWORD_SHORT]: 'パスワードを選択する',
  [k.ERROR_OCCURED]:
    'エラーが発生した。もう一度試してみて。エラーが繰り返し発生する場合は、私達に電子メールを送ることができる：',
  [k.PASSWORD_ALREADY_EXISTING_TITLE]: 'あなたはすでにパスワードを持っている',
  [k.PASSWORD_ALREADY_EXISTING]: 'すでにパスワードが設定されている。あなたは',
  [k.GO_TO_WEDDING]: '結婚式のホームページへ行き、登録する',
  [k.I_AGREE]: '私は受け入れる',
  [k.REGISTER_NOW]: '今すぐ登録する',
  [k.YOUR_FREE_WEDDING_WEBSITE]: 'あなたの無料の結婚式のホームページ！',
  [k.ALREADY_CREATED_WEDDINGS]:
    'あなたはすでに次の結婚式のホームページを作成した。あなたはおそらく、新しいものを作成するのではなく、既存の結婚式のホームページを編集することを好むだろう。ちょうど下をクリックする。',
  [k.WEDDING]: '結婚式のホームページ',
  [k.ENTER_PASSWORD]: 'パスワードを入力する',
  [k.USER_ALREADY_EXISTING]:
    '我々はすでにこのメールアドレスを持つ登録ユーザーがいる。あなたのパスワードを入力してください。',
  [k.BACK]: '戻る',
  [k.LOGIN]: 'ログインする',
  [k.FORGOT_PASSWORD]: 'パスワードをお忘れの場合こちらをクリック',
  [k.MAIL_SENT]: 'Eメールを送信した。メールに記載されているリンクをクリックし、パスワードをリセットする。',
  [k.OK]: 'OK',
  [k.PERFECT]: '完璧だ',
  [k.NAME_OF]: '名前は？',
  [k.SPOUSE_M]: 'あなたが選んだもの',
  [k.SPOUSE_F]: '選んだもの',
  [k.NEXT]: '次へ',
  [k.WHATS_YOUR_NAME]: '素晴らしい！あなたの名前は？',
  [k.PREPARING_1]: '私たちはあなたの結婚式のアプリを準備している...',
  [k.PREPARING_2]: 'あなたの選んだデザインを保存する',
  [k.PREPARING_3]: '最終調整...',
  [k.FINISHED_ENTER_MAIL]:
    '完了！私たちはあなたの結婚式のアプリを保存し、あなたのログイン情報を送信できるようにメールアドレスを入力してください。',
  [k.ACCEPT_TERMS]: '利用規約に同意する。',
  [k.ENTER_VALID_MAIL]: '有効なメールアドレスを入力する。',
  [k.QUESTION_BRIDE_OR_GROOM]: 'あなたは新郎新婦？',
  [k.QUESTION_WEDDING_DATE]: '結婚式の日付を知っている？',
  [k.YES_WE_KNOW]: 'はい！',
  [k.NO_WE_DONT_KNOW]: 'いいえ、まだ',
  [k.MAKE_SELECTION]: '選択する',
  [k.QUESTION_WEDDING_LOCATION]: '場所は決まっている？',
  [k.YES_WE_HAVE]: 'はい！',
  [k.ENTER_YOUR_LOCATION]: 'あなたの結婚式の場所を入力しなさい。',
  [k.LOCATION_CLASSIC]: 'クラシック',
  [k.LOCATION_COUNTRY]: 'カントリー',
  [k.LOCATION_OUTDOOR]: 'アウトドア',
  [k.LOCATION_PALACE_HOTEL]: 'キャッスル',
  [k.QUESTION_WEDDING_STYLE]: 'ご希望のスタイルは？',
  [k.HOTEL]: 'ホテル',
  [k.INFOS]: '情報',
  [k.LOCATION]: 'ロケーション',
  [k.PHOTOS]: '写真',
  [k.NO_MUSIC_SAVED]: 'まだ保存されている曲がない...',
  [k.SEARCH_FOR_SONGS]: '上でお気に入りの曲を検索する！',
  [k.LISTEN_TO_FULL_LIST]: '結婚式のフル・プレイリストを聴く',
  [k.OPEN_IN_SPOTIFY]: 'Spotify で開く',
  [k.LISTEN_TO_SINGLE_SONGS]: 'プレイリストの個々の曲を聴く',
  [k.NO_RESULT_FOUND]: '結果が見つからない',
  [k.CANCEL]: 'キャンセルする',
  [k.ADD_SONG]: '曲を追加する',
  [k.NO_PHOTOS_UPLOADED_YET]: 'まだ写真がアップロードされていない...',
  [k.ADD_SOME_PHOTOS]: '上をクリックして写真を撮る',
  [k.DROP_PHOTOS_HERE_OR]: 'ここに写真を保存する',
  [k.SHOOT_PHOTO]: '写真を撮る',
  [k.OVERVIEW_OF_ALL_PRESENTS]: 'すべてのギフトとエントリーを見る',
  [k.LOADING_BACKINGS]: 'エントリーが読み込まれた...',
  [k.NO_PRESENTS_YET]: 'まだギフトを登録していない。',
  [k.PRESENT]: 'ギフトを追加する',
  [k.E_MAIL_ADDRESS]: 'Eメールアドレス',
  [k.DATE]: 'ギフトの日付',
  [k.NO_BACKINGS_YET]: 'まだ入力していない',
  [k.CLOSE]: '閉じる',
  [k.ONLY_VISIBLE_FOR_WEDDING_COUPLE]: '(新郎新婦のみ表示される）',
  [k.SHOW_ALL_ENTRIES]: 'すべてのエントリーを表示する',
  [k.EUR]: '金額 EUR',
  [k.ADD_BACKING]: '参加する',
  [k.BUY]: '今すぐ購入する',
  [k.YOUR_BACKING_SAVED]: 'ログインしている',
  [k.A_GUEST_ALREADY_BACKED]: 'ゲストが既に登録されている',
  [k.DELETE_MY_BACKING]: 'エントリーを削除する',
  [k.OVERVIEW_OF_ALL_RSVPS]: 'すべての登録の概要',
  [k.LOADING_RSVPS]: '登録が読み込まれている...',
  [k.NO_RSVPS_YET]: 'まだ返信カードが届いていない',
  [k.RESPONSE]: '返信',
  [k.GUESTS_AND_MENU_WISH]: 'ゲストとメニューのリクエスト',
  [k.QUESTIONS_AND_REMARKS]: '質問/コメント',
  [k.WILL_ATTEND]: 'コミットメント',
  [k.WILL_NOT_ATTEND]: 'キャンセル',
  [k.SHOW_ALL_RSVPS]: 'すべてのリクエストを表示する',
  [k.YOU_ALREADY_SUBMITTED_ON]: 'への返信は送信済み',
  [k.CANNOT_CHANGE_ANY_MOR]: 'は送信済みである。内容は変更できない。',
  [k.MENU_WISH]: 'リクエストメニュー',
  [k.RSVP_LOADING]: '回答カード読み込み中',
  [k.LIST_EVERYONE_WE_MAY_EXPECT]: '以下のリストを作成してほしい。',
  [k.LIST_EVERYONE_WE_MAY_EXPECT_WITH_MENU]: 'ご予定の人数とメニューのご希望を以下にご記入ください。',
  [k.GUEST]: 'ゲスト',
  [k.ADD_GUEST]: 'ゲストを追加する',
  [k.SUBMIT_RSVP]: '返信カードを送る',
  [k.WEBSITE]: 'ウェブサイト',
  [k.OUR_PACKAGES]: 'パッケージ',
  [k.PACKAGE_BASIC]: 'ベーシック',
  [k.PACKAGE_COMPLETE]: 'コンプリート',
  [k.PACKAGE_PREMIUM]: 'プレミアム',
  [k.PACKAGE_VIP]: 'VIP',
  [k.BEST_SELLER]: 'ベストセラー',
  [k.SELECTED]: '厳選された',
  [k.SELECT]: 'セレクト',
  [k.CAN_UPGRADE_LATER]: '差額をお支払いいただくだけで、後からいつでもアップグレードできるのでご安心を。',
  [k.LOOK_IN_FAQ]: 'まだ質問がある？よくある質問をチェックする！',
  [k.PACKAGE_FEATURES_DESIGN]: 'デザイン、色、フォント',
  [k.PACKAGE_FEATURES_SUBDOMAIN]: 'パスワード付きサブドメイン',
  [k.PACKAGE_FEATURES_MOBILE]: 'デスクトップ＆モバイル最適化',
  [k.PACKAGE_FEATURES_SCHEDULE]: 'タイムテーブル付きデイリースケジュール',
  [k.PACKAGE_FEATURES_LOCATION]: 'ロケーションプランナーと情報',
  [k.PACKAGE_FEATURES_INFOS]: '情報ページ（FAQ、ギフトなど）',
  [k.PACKAGE_FEATURES_RSVP]: 'ゲスト登録と管理',
  [k.PACKAGE_FEATURES_MUSIC]: 'ゲストによる音楽リクエスト',
  [k.PACKAGE_FEATURES_PHOTOS]: 'ゲストの写真のアップロード',
  [k.PACKAGE_FEATURES_SUPPORT]: 'Eメールによるカスタマーサービス',
  [k.PACKAGE_FEATURES_MULTILANGUAGE]: '多言語ウェブサイト',
  [k.PACKAGE_FEATURES_OWN_DOMAIN]: '独自ドメイン（.de）',
  [k.PACKAGE_FEATURES_CUSTOM_DESIGN]: 'プロによるカスタムデザイン',
  [k.MAX_FIVE]: '最大5',
  [k.CHECKING_PAYMENT_STATUS]: '支払い状況を確認する',
  [k.PAYMENT_SUCCESSFULL]:
    'ありがとう！お支払いは成功しました、あなたは今、次のパッケージであなたの結婚式アプリを使用することができる：',
  [k.PAYMENT_FAILED]: '残念ながら、支払いが失敗した。再度お試しいただくか、次のメールアドレスまでご連絡を。',
  [k.ACTIVATE_PACKAGE_NOW]: 'ロックを解除する',
  [k.PAY]: '支払う',
  [k.EDITING_MODE]: '編集モード',
  [k.ACTIVE]: '有効である',
  [k.NOT_ACTIVE]: 'アクティブではない',
  [k.ERROR_OCCURED_WITH_MESSAGE]: 'エラーが発生した。技術的なフィードバック',
  [k.TRY_AGAIN_PLEASE]:
    'もう一度試してみる。エラーが繰り返し発生する場合は、次のアドレスに電子メールを送ることができる。',
  [k.PACKAGE_UPGRADE]: 'パッケージのアップグレード',
  [k.PACKAGE_ALREADY_BOUGHT]: 'あなたはすでにあなたの結婚式のためのパッケージを購入した。',
  [k.UPGRADE_TO_HIGHER_PACKAGE]:
    'もちろん、差額を支払うだけで、ウェブサイトをより高いパッケージにアップグレードすることができる。ショートメールをお送りいただければ、すべて対応させていただきます。',
  [k.REGISTRATION_NOT_COMPLETE]: '登録がまだ完了していない。お送りしたリンクをクリックしてください。',
  [k.YOU_HAVE_AN_EMAIL]: '弊社からのEメールを受信した。',
  [k.YOU_MUST_REGISTER_FIRST]: 'あなたの結婚式のウェブサイトを編集するには、登録を完了する必要がある。',
  [k.CREATOR_MUST_REGISTER]:
    'それはすべて無料で、非常に迅速です：私たちはあなたに送られたメール内のリンクをクリックするだけ。メールが見つからない？問題ない、ちょうどここをクリックする：',
  [k.HERE]: 'ここをクリック',
  [k.E_MAIL_RESENT]: 'メールが再び送信された。',
  [k.CONFIRMATION_RESENT_TO]: '確認リンクを再送した：',
  [k.CAN_TAKE_SOME_MINUTES]:
    'メールが届くまで数分かかる場合がある。問題が解決しない場合は、Eメールでお問い合わせください：',
  [k.RESENDING_MAIL]: 'メールが再度送信される。',
  [k.DEMO_WEDDING_HINT]: 'デモサイト - 無料で自分のサイトを作成して試してみる！',
  [k.CREATE_OWN_WEBSITE]: 'あなた自身のウェブサイトを作成する！',
  [k.SOME_FEATURES_DEACTIVATED_IN_DEMO]: 'デモサイトでは、いくつかの機能が無効になっている。',
  [k.CAN_CREATE_OWN_WEDDING_WEBSITE]:
    '登録し、あなた自身の結婚式のウェブサイトを作成し、すべての機能を無料で試すことができる！',
  [k.NO_PACKAGE_BOUGHT_HINT]:
    '無料ベーシックバージョン - 今すぐアップグレードして、写真、ゲスト、その他の機能を無制限にしよう。',
  [k.LETS_UPGRADE]: 'アップグレードしよう',
  [k.MAX_NUMBER_FOR_BASIC_PACKAGE]: 'あなたは、無料の基本的なパッケージのための写真の最大数に達している。',
  [k.UPGRADE_FOR_UNLIMITED_PHOTOS]: 'プレミアムプランにアップグレードすると、写真のアップロード枚数が無制限に。',
  [k.UPGRADE_FOR_UNLIMITED_MUSIC]: 'プレミアムプランにアップグレードして、曲数を無制限に追加する。',
  [k.CONFIRM_DELETE_TITLE]: '削除を確認する',
  [k.CONFIRM_DELETE_TEXT]: 'このアイテムを削除してもよろしいですか？',
  [k.DELETE]: 'アイテムを削除する',
  [k.ADD_ELEMENT]: '新しいアイテムを追加する',
  [k.WHICH_ELEMENT_TO_ADD]: '追加するアイテムの種類は？',
  [k.SELECT_ICON_FOR_LOCATION]: '場所のアイコンを選ぶ',
  [k.IMAGE_POSITION]: '画像の位置',
  [k.SELECT_IMAGE]: '画像を選択する',
  [k.UPLOAD]: '画像をアップロードする',
  [k.SELECTED_IMAGE]: '選択した画像',
  [k.NO_IMAGE]: '画像なし',
  [k.OTHER_IMAGE]: 'ギャラリー画像',
  [k.EDIT_WEDDING_BASE_DATA]: '結婚式の詳細を編集する',
  [k.ENTER_NAME_OF_BRIDE]: '新婦の名前を入力する',
  [k.ENTER_NAME_OF_GROOM]: '新郎の名前を入力する',
  [k.SELECT_DATE]: '日付を選択する。',
  [k.HINT_CHANGE_URL]:
    '注：あなたの結婚式のウェブページが利用できるアドレスを変更したい場合は、私達に電子メールを送信してください：',
  [k.EDIT_COUNTDOWN]: 'ウェディングカウントダウンを編集する',
  [k.EDIT_INFO_BOX]: '情報ボックスを編集する',
  [k.EDIT_BOX_WITH_LARGE_PHOTO]: '大きな写真でボックスを編集する',
  [k.EDIT_LOCATION]: '場所を編集する',
  [k.EDIT_PLACE]: '場所を編集する',
  [k.ADD_LOCATION]: 'ロケーションを追加する',
  [k.ADD_PLACE]: 'ロケーションを追加する',
  [k.SELECT_SEARCH_RESULT]: '検索結果を選択する。',
  [k.EDIT_PAGE_TITLE]: 'ページタイトルを編集する',
  [k.EDIT_PRESENTS]: 'ギフト レジストリを編集する',
  [k.PRESENT_INTRO_TEXT]: '自分だけのオリジナルギフトレジストリを作成して、ゲストのインスピレーションを刺激しよう。',
  [k.ADDITIONAL_ENTRY]: 'エントリーを増やす',
  [k.EDIT_RSVP]: 'RSVPを編集する',
  [k.MENU_WISHES_ACTIVATED]: 'RSVPの際、ゲストにメニューの好みを伝えてほしい？',
  [k.EDIT_SCHEDULE_ITEM]: 'メニュー項目を編集する',
  [k.NAVIGATION]: 'メニューを設定する',
  [k.COUPLE]: '新郎新婦メニュー',
  [k.MUSIC]: '音楽メニュー',
  [k.YOU_ARE_LOGGED_IN_AS_GROOM]: 'あなたは新郎として登録されている',
  [k.YOU_ARE_LOGGED_IN_AS_BRIDE]: 'あなたは新婦として登録されている',
  [k.ADDRESS_OF_YOUR_PAGE]: 'あなたの結婚式のウェブサイトのアドレス',
  [k.WEDDING_CODE_FOR_GUESTS]: 'あなたのゲストのための結婚式のコード：',
  [k.CURRENT_PACKAGE]: '現在のパッケージ',
  [k.UPGRADE]: 'アップグレードする',
  [k.LOGOUT]: 'ログアウトする',
  [k.FOR_GUESTS]: 'ゲスト用',
  [k.INVISIBLE]: '見えない',
  [k.VISIBLE]: '見える',
  [k.WEDDING_NOT_FOUND]: 'ウェディングページが見つからない。',
  [k.WEDDING_NOT_FOUND_TEXT]:
    '申し訳ございませんが、入力されたアドレスに結婚式のウェブページが見つからなかった。入力ミスではないか？もう一度お試しください。',
  [k.IF_ERROR_REPEATS]: '何度もエラーが発生する場合は、次のアドレスにメールを送ることができる。',
  [k.ERROR_GENERAL]: 'エラーが発生した',
  [k.SORRY_WRITE_MAIL]:
    '申し訳ない。もう一度お試しください。何度もエラーが発生する場合は、電子メールでお問い合わせください。',
  [k.MOVE_UP]: '上に移動する',
  [k.MOVE_DOWN]: '下にスクロールする',
  [k.OH_SORRY]: 'なんてことだ...間違ってしまった...',
  [k.ERROR_REFRESH_PAGE]:
    '申し訳ない。ページをリロードして再度お試しください。何度もエラーが発生する場合は、下記までメールでご連絡を。',
  [k.IF_YOU_WANT_TO_HELP]:
    'もし、私たちがより早くエラーを発見し、修正することをお望みであれば、以下のテキストをメールにコピーしていただけると助かる：',
  [k.ENTER_DISPLAY_NAME]: '素晴らしい！あなたの名前を入力してください。アップロードした写真の下に表示される。',
  [k.ENTER_DISPLAY_NAME_SHORT]: '名前を入力してください。',
  [k.WE_SENT_EMAIL]: 'メールを送信した。メールに記載されているリンクをクリックして、パスワードをリセットする。',
  [k.WELCOME_BACK]: 'おかえりなさい、',
  [k.ALMOST_THERE]: 'もう少しだ、',
  [k.PLEASE_SET_PASSWORD]: 'パスワードを選択する',
  [k.PLEASE_SET_PASSWORD_SHORT]: 'パスワードを選択する',
  [k.WELCOME_TO_WEDDING_OF]: 'のウェディングサイトへようこそ',
  [k.PLEASE_ENTER_MAIL]: '!あなたのメールアドレスを入力してください。',
  [k.WELCOME_TO_EHO]:
    'EureHochzeitOnline.comの結婚式のプラットフォームへようこそ！あなたのメールアドレスを入力してください。',
  [k.TO_WEDDING]: '結婚式のために',
  [k.ENTER_WEDDING_CODE]: '!結婚式のコードを入力する。',
  [k.ENTER_WEDDING_CODE_SHORT]: '結婚式のコードを入力する',
  [k.RESTART]: '再スタートする',
  [k.UPLOAD_PREPARING]: 'アップロード準備中',
  [k.UPLOAD_STARTED]: 'アップロード中...',
  [k.UPLOAD_FINISHING]: 'アップロードが完了した',
  [k.UPLOAD_CANCELED]: 'アップロードがキャンセルされた',
  [k.INVALID_FILE_TYPE]: 'ファイルの種類が無効である',
  [k.MAX_FILE_NUMBER]: '最大ファイル数を超えた...',
  [k.FILE_TOO_LARGE]: 'ファイルが大きすぎる。',
  [k.DAYS_TO_GO]: 'あと数日',
  [k.DAY_TO_GO]: 'あと1日だ！',
  [k.TODAY]: '今日',
  [k.INVALID_DATE]: '日付が無効である',
  [k.DATE_MUST_BE_IN_FUTURE]: '日付は未来でなければならない',
  [k.ADDRESS_OR_NAME_OF_LOCATION]: '場所の住所または名前',
  [k.ENTER_SONG_WISH]: '好きな曲をここに入力する',
  [k.NAME_OF_GUEST]: 'お客様のお名前',
  [k.QUESTION_REMARK_MAX_1000]: '質問/コメント（1000文字以内）',
  [k.LEFT]: 'リンク',
  [k.TOP]: 'トップ',
  [k.RIGHT]: '右',
  [k.BOTTOM]: '下',
  [k.NAME_OF_BRIDE]: '新婦の名前',
  [k.NAME_OF_GROOM]: '新郎氏名',
  [k.TITLE]: 'タイトル',
  [k.DESCRIPTION]: 'イベント内容',
  [k.NAME_OF_PLACE]: '会場名',
  [k.STREET]: '通り',
  [k.HOUSENUMBER]: '番地',
  [k.ZIP]: '郵便番号',
  [k.CITY]: '市町村',
  [k.COUNTRY]: '国/州',
  [k.HINTS_FOR_GUESTS]: 'ゲストのためのメモ',
  [k.TITLE_FOR_THIS_PAGE]: 'このページのタイトル',
  [k.SUBTITLE_FOR_THIS_PAGE]: 'このページのサブタイトル',
  [k.LABEL]: '指定',
  [k.AMAZON_URL]: 'アマゾンのURL（オプション）',
  [k.COSTS]: '費用',
  [k.NEW_FOOD_OPTION]: '新メニューオプション',
  [k.TIME]: '時間',
  [k.SCHEDULE_ITEM]: 'プログラム項目',
  [k.YOUR_NAME_OR_NICKNAME]: 'お名前またはニックネーム',
  [k.YOUR_EMAIL_ADDRESS]: 'メールアドレス',
  [k.YOUR_WEDDING_CODE]: 'ウェディングコード',
  [k.COULD_NOT_SAVE_WEDDING]: '申し訳ございませんが、結婚式を保存することができなかった。',
  [k.ALREADY_HAVE_WEDDING]: 'あなたはすでに結婚式のホームページを持っている',
  [k.CREATE_NEW]: '新しいものを作成する',
  [k.COULD_NOT_LOAD_YOUR_DATA]: '我々はあなたの情報を取得できなかった。',
  [k.COULD_NOT_SEND_MAIL]: 'メールを送信できなかった',
  [k.DELETE_IMAGE]: '画像を削除する',
  [k.DELETE_IMAGE_ARE_YOU_SURE]: 'この画像を削除してもよろしいですか？',
  [k.COULD_NOT_LOGIN]: 'ログインできなかった。',
  [k.WRONG_PASSWORD_TITLE]: 'パスワードが間違っている',
  [k.WRONG_PASSWORD_TEXT]: '入力したパスワードが間違っている',
  [k.WRONG_CODE_TITLE]: 'ウェディングコードが正しくない',
  [k.WRONG_CODE_TEXT]: '入力したウェディングコードが正しくない。',
  [k.LOADING]: '読み込み中',
  [k.GUEST_NAME_MISSING]: '次のゲストの名前を入力する',
  [k.GUEST_FOOD_MISSING]: '次のゲストのメニューをリクエストする：',
  [k.LIMIT_EXCEEDED_PASSWORD_RESET]: '試行回数の上限を超えた。後で再試行できる。',
  [k.EXPIRED_CODE_PASSWORD_RESET]: 'このリンクを使用してパスワードをリセットした。',
  [k.PLEASE_ENTER_NAME]: '名前を入力する',
  [k.COUNTDOWN_VISIBLE]: 'カウントダウンが表示されている',
  [k.COUNTDOWN_NOT_VISIBLE]: 'カウントダウンが表示されていない。',
  [k.ASK_FOR_MENU_WISHES]: 'はい、メニューをリクエストする',
  [k.ASK_NOT_FOR_MENU_WISHES]: 'いいえ、メニューをリクエストしない',
  [k.SPRING]: '春',
  [k.SUMMER]: '夏',
  [k.AUTUMN]: '秋',
  [k.WINTER]: '冬',
  [k.COULD_NOT_SAVE_PASSWORD]: 'パスワードを保存できなかった',
  [k.YES_WE_WILL_ATTEND]: 'はい、結婚式に出席する',
  [k.NO_WE_WILL_NOT_ATTEND]: 'いいえ、出席しない',
  [k.CONFIRM_DIALOG_TITLE]: 'よろしいですか？',
  [k.ALERT_DIALOG_TITLE]: '備考',
  [k.DEFAULT_IMAGES_TYPE_CAKE]: 'ウェディングケーキ',
  [k.DEFAULT_IMAGES_TYPE_CEREMONY]: '挙式',
  [k.DEFAULT_IMAGES_TYPE_CHAMPAGNERECEPTION]: 'レセプションとシャンパン',
  [k.DEFAULT_IMAGES_TYPE_DANCE]: 'ダンスとパーティー',
  [k.DEFAULT_IMAGES_TYPE_FOOD]: 'ウェディングディナー＆ビュッフェ',
  [k.DEFAULT_IMAGES_TYPE_CAR]: 'ウェディングカーとパレード',
  [k.DEFAULT_IMAGES_TYPE_GAME]: 'ゲームとエンターテイメント',
  [k.DEFAULT_IMAGES_TYPE_DRESSCODE]: 'ドレスコード',
  [k.DEFAULT_IMAGES_TYPE_HOTEL]: 'ホテルと宿泊施設',
  [k.DEFAULT_IMAGES_TYPE_PHOTO]: '写真撮影',
  [k.DEFAULT_IMAGES_TYPE_PRESENT]: 'ギフトとプレゼント',
  [k.DEFAULT_IMAGES_TYPE_LOVE]: '一般と恋愛',
  [k.DEFAULT_ELEMENT_TEXT_PAGE_TITLE_LABEL]: 'ページタイトル',
  [k.DEFAULT_ELEMENT_TEXT_PAGE_TITLE_TITLE]: 'ページタイトル',
  [k.DEFAULT_ELEMENT_TEXT_PAGE_TITLE_SUBTITLE]: 'このページへようこそ',
  [k.DEFAULT_ELEMENT_TEXT_SCHEDULE_ITEM_LABEL]: 'プログラム項目',
  [k.DEFAULT_ELEMENT_TEXT_SCHEDULE_ITEM_TITLE]: 'プログラム項目',
  [k.DEFAULT_ELEMENT_TEXT_SCHEDULE_ITEM_TIME]: '15:00より',
  [k.DEFAULT_ELEMENT_TEXT_SCHEDULE_ITEM_DESCRIPTION]: '集合写真',
  [k.DEFAULT_ELEMENT_TEXT_INFO_ITEM_LABEL]: 'インフォボックス',
  [k.DEFAULT_ELEMENT_TEXT_INFO_ITEM_TITLE]: '🍰 ケーキ',
  [k.DEFAULT_ELEMENT_TEXT_INFO_ITEM_DESCRIPTION]:
    ' ケーキを作りたい方は、ご一報を。色とりどりのケーキをご用意してお待ちしております。',
  [k.DEFAULT_ELEMENT_TEXT_LARGE_PHOTO_ITEM_LABEL]: '大きな写真入りボックス',
  [k.DEFAULT_ELEMENT_TEXT_LARGE_PHOTO_ITEM_TITLE]: '自己紹介',
  [k.DEFAULT_ELEMENT_TEXT_LARGE_PHOTO_ITEM_DESCRIPTION]: 'ゲストへの自己紹介。お二人の出会いをお聞かせください。',
  [k.DEFAULT_ELEMENT_TEXT_LOCATION_MAP_LABEL]: 'ロケーションマップ',
  [k.DEFAULT_ELEMENT_TEXT_LOCATION_ITEM_LABEL]: 'ウェディングロケーション',

  [k.DEFAULT_STYLES_MODERN_TITLE]: `モダン`,
  [k.DEFAULT_STYLES_MODERN_DESCRIPTION]: `時代の息吹を感じる雰囲気の中で、愛を輝かせましょう。`,
  [k.DEFAULT_STYLES_KLASSISCH_TITLE]: `クラシック`,
  [k.DEFAULT_STYLES_KLASSISCH_DESCRIPTION]: `洗練されたライン、調和のとれた色彩、そして少しの華やかさが、あなたの愛を讃える雰囲気を作り出します。`,
  [k.DEFAULT_STYLES_VINTAGE_TITLE]: `ヴィンテージ`,
  [k.DEFAULT_STYLES_VINTAGE_DESCRIPTION]: `ヴィンテージスタイルは、過去の時代の魅力を、ノスタルジーとエレガンスを加えてよみがえらせます。`,
  [k.DEFAULT_STYLES_FLOWER_TITLE]: `フラワー`,
  [k.DEFAULT_STYLES_FLOWER_DESCRIPTION]: `このウェディングスタイルは、花々の自然な美しさを存分に祝います。`,
  [k.DEFAULT_STYLES_BOHO_TITLE]: `ボヘミアン`,
  [k.DEFAULT_STYLES_BOHO_DESCRIPTION]: `自然と創造性が調和する、自由な精神にぴったりのリラックスした個性的な雰囲気です。`,
  [k.DEFAULT_STYLES_BLOSSOM_TITLE]: `ブロッサム`,
  [k.DEFAULT_STYLES_BLOSSOM_DESCRIPTION]: `花々とフローラルエレメントの繊細な美しさを引き立てる、ロマンチックなスタイルです。`,
  [k.NOT_SURE_ABOUT_DESIGN]: `デザインが確定していませんか？心配ありません。後でスタイルを変更してもデータは失われません。`,
  [k.OWN_PHOTOS_AFTER_REGISTRATION]: `無料登録後にご自身の写真やロゴをアップロードできます。`,
  [k.YOUR_NAMES]: `あなたのお名前`,
  [k.YOUR_WEDDING_DATE]: `あなたの結婚式の日付`,
  [k.WEDDING_DATE_FIX]: `結婚式の日付が決まっています`,
  [k.WEDDING_DATE_NOT_FIX]: `結婚式の日付は決まっていません`,
  [k.YOUR_WEDDING_STYLE]: `ウェブサイトのスタイル`,
  [k.OWN_LOGO]: `ご自身のロゴ`,
  [k.START_PHOTO]: `トップページの写真`,
  [k.USE_START_PHOTO]: `ご自身の写真を使用しますか？`,
  [k.WITH_START_PHOTO]: `ご自身の写真を使用`,
  [k.WITHOUT_START_PHOTO]: `ご自身の写真を使用しない`,
  [k.ALL_STYLES]: `すべてのスタイル`,

  [k.COOKIES_01]: 'ウエディングクッキーを贈ろう',
  [k.COOKIES_02]:
    "すべてを確認」をクリックすると、すべてのクッキーを受け入れる。または、カスタム選択することもできる。クッキーの設定 'からいつでも選択を取り消すことができる。",
  [k.COOKIES_03]: '必要なクッキー',
  [k.COOKIES_04]: 'これらのクッキーはサイトの機能に必要なため、無効にすることはできない。',
  [k.COOKIES_05]: '詳細はこちら',
  [k.COOKIES_06]: 'マーケティングおよびパーソナライゼーションクッキー',
  [k.COOKIES_07]:
    'これらのクッキーを使用することで、お客様のユーザー行動に合わせたウェブサイトコンテンツを受け取ることができ、利用統計に基づき、お客様の関心に合わせてウェブサイトをカスタマイズすることができる。',
  [k.COOKIES_08]: '選択を受け入れる',
  [k.COOKIES_09]: 'すべてを受け入れる',
  [k.TERMS_AND_CONDITIONS_00]: '利用規約',
  [k.TERMS_AND_CONDITIONS_01]:
    'fidira Software UG (haftungsbeschränkt) (以下、「プロバイダー」、「弊社」または「EureHochzeitOnline.com」ともいう)は、個々のウェディングアプリケーションを作成するためのプラットフォームを提供する。これらのアプリケーションにより、ホストである利用者（以下、総称して「利用者」という）は、結婚式用のアプリケーションを作成し、このアプリケーションを通じて結婚式に関する情報や交流の機会をゲストに提供することができる。本規約は、本プラットフォームの利用に関して適用される。',
  [k.TERMS_AND_CONDITIONS_02]: '§ 第1条 プラットフォームの利用',
  [k.TERMS_AND_CONDITIONS_03]:
    '本プラットフォームの利用は、トライアルバージョンでは通常無料である。本プラットフォームを規定人数以上の結婚式に使用する場合は、1回限りの料金を支払う必要がある。トライアル版とフルバージョンの両方において、事前の登録とユーザーアカウントの作成が必要となる。利用者は自分のアカウントを第三者に使用させることはできない。ユーザーは、自身のアクセスデータを秘密にし、第三者によるアクセスから保護する義務を負う。',
  [k.TERMS_AND_CONDITIONS_04]:
    'ウェディングアプリは、挙式後6ヶ月間利用可能である。その後、ウェディングアプリを停止し、他のカップルに希望のアドレスを提供できるようにする。それ以上の期間、ウエディングアプリをオンラインに保つ必要がある場合は、特別な取り決めをすることができる。',
  [k.TERMS_AND_CONDITIONS_05]:
    'ウェディングアプリは一旦作成されると、一つのウェディングにのみ使用することができる。例えば、利用者がウェディングアプリを他のカップルに譲渡または販売したことが判明した場合、当社はそのような利用を防止し、それ以降のウェディングの料金を請求する権利を留保する。',
  [k.TERMS_AND_CONDITIONS_06]: '§ 第 2 条 データ保護',
  [k.TERMS_AND_CONDITIONS_07]: '本ソフトウェアを使用することにより、利用者は以下の事項に同意するものとする。',
  [k.TERMS_AND_CONDITIONS_08]: 'データ保護',
  [k.TERMS_AND_CONDITIONS_09]: '規定に同意するものとする。',
  [k.TERMS_AND_CONDITIONS_10]: '§3 EureHochzeitOnline.comの機能とサービス',
  [k.TERMS_AND_CONDITIONS_11]:
    'EureHochzeitOnline.comを通じて作成できる個々の結婚式アプリケーションは以下の機能を提供する。',
  [k.TERMS_AND_CONDITIONS_12]: 'カスタマイズ：',
  [k.TERMS_AND_CONDITIONS_13]:
    '例えば、結婚式の招待状のグラフィックデザインに合わせて、背景、画像、色、フォントを選択することができる。',
  [k.TERMS_AND_CONDITIONS_14]: 'フォトギャラリー：',
  [k.TERMS_AND_CONDITIONS_15]:
    'ゲストは結婚式の前や最中に写真を撮ってアップロードすることができる。これらの写真は、自動的に更新されるライブ画像ギャラリーに表示することができる。',
  [k.TERMS_AND_CONDITIONS_16]: '音楽のリクエスト：',
  [k.TERMS_AND_CONDITIONS_17]:
    'ゲストは検索機能を使って結婚式の曲をリクエストし、そのリクエストを評価することができる。ホストはこの機能を使って曲を選ぶことができる。',
  [k.TERMS_AND_CONDITIONS_18]: '結婚式情報：',
  [k.TERMS_AND_CONDITIONS_19]:
    'ホストは、ゲストのために、会場とインタラクティブマップ、スケジュール、その他の情報をウェディングアプリで公開できる。',
  [k.TERMS_AND_CONDITIONS_20]:
    'EureHochzeitOnline.comは、ソフトウェアの機能の範囲とデザインをいつでも変更する権利を有する。',
  [k.TERMS_AND_CONDITIONS_21]:
    '機能を使用するには、最新のインターネットブラウザを備えた最新のスマートフォン、タブレット、またはPCが必要である。特に、写真アップロード、結婚式クイズ、音楽リクエストなどのライブ機能には、安定した高速インターネット接続が必要である。EureHochzeitOnline.comは、提供されるコンテンツの正確性、完全性、信頼性、適時性、有用性に関して一切の責任を負わない。',
  [k.TERMS_AND_CONDITIONS_22]:
    'EureHochzeitOnline.comがホストにアナウンスするメンテナンス作業中、プラットフォームが一時的に利用できなくなることがある。私どもはサービスを利用可能な状態に保つためにあらゆる努力をしており、利用者の期待を裏切ったことは一度もないと自負している。しかしながら、弊社はそれ以上の義務を負うことはできず、特に利用者がサービスを常に利用できるようにする権利はない。',
  [k.TERMS_AND_CONDITIONS_23]: '§ 第4条 利用者の義務',
  [k.TERMS_AND_CONDITIONS_24]:
    '利用者は、ゲストまたはホストとして、EureHochzeitOnline.comプラットフォーム上に自身のコンテンツやファイルを保存し、公開することができる。利用者はこのコンテンツに責任を持つ。利用者は、一般的な良識や適用される法律に違反する記事、ファイル、結婚式情報、その他のコンテンツを公開しないことを約束する。特に、利用者は、記事、ファイル、結婚式の情報、またはその他のコンテンツを公開しないことに同意する。',
  [k.TERMS_AND_CONDITIONS_25]: 'その公表が刑事犯罪または行政犯罪を構成する、',
  [k.TERMS_AND_CONDITIONS_26]: '著作権法、商標法、競争法に違反するもの',
  [k.TERMS_AND_CONDITIONS_27]: '法律サービス法に違反するもの',
  [k.TERMS_AND_CONDITIONS_28]: '攻撃的、人種差別的、差別的、ポルノ的な内容を含むもの。',
  [k.TERMS_AND_CONDITIONS_29]: '広告を含むもの',
  [k.TERMS_AND_CONDITIONS_30]:
    'EureHochzeitOnline.comは、これらの義務に違反する、または違反する疑いのあるコンテンツを変更または削除する権利を有する。EureHochzeitOnline.comはまた、利用者が利用規約に違反した場合、利用者のアクセスおよび設定されたウェディングアプリケーションをブロックする権利を有する。利用者は、義務違反によって生じた損害を提供者に賠償するものとする。提供者は、利用者の権利侵害により第三者から請求された場合、利用者に賠償を請求する権利を有する。利用者は、かかる請求の防御において提供者を支援する義務を負う。また、利用者は、プロバイダの適切な法的防御のための費用を負担する義務を負う。',
  [k.TERMS_AND_CONDITIONS_31]: '§ 第5条 知的財産',
  [k.TERMS_AND_CONDITIONS_32]: '利用者の知的財産',
  [k.TERMS_AND_CONDITIONS_33]:
    '利用者が投稿したコンテンツ、テキスト、画像、その他の資料の知的財産権は、利用者に帰属する。EureHochzeitOnline.comは、そのようなコンテンツの知的財産権を主張しない。ただし、お客様は、EureHochzeitOnline.comが、結婚式のゲストに提供する目的で、これらのコンテンツにアクセスし、コピーし、配布することを許可する。また、お客様は、バックアップコピーの作成、サポート担当者へのアクセス提供など、当社のサービスを提供するために必要なその他の行為を行うことを許可する。',
  [k.TERMS_AND_CONDITIONS_34]: '当社の知的財産',
  [k.TERMS_AND_CONDITIONS_35]:
    '提供者は、利用規約に従って提供される定期的に作成される婚礼アプリケーション以外では、EureHochzeitOnline.comのウェブサイトまたはソフトウェアプラットフォームの知的財産権を使用するライセンスまたはその他の権利を付与しない。知的財産権の複製、頒布、複製、送信、または第三者への提供を含むその他の使用は、提供者の事前の書面による同意がない限り認められない。',
  [k.TERMS_AND_CONDITIONS_36]: '§ 第6条 退会権',
  [k.TERMS_AND_CONDITIONS_37]:
    'お客様は、14日以内に、理由を述べずに本契約から離脱する権利を有する。撤回期間は、契約締結から14日間とする。お客様は、以下の宛先に電子メールを送信することにより、撤回権を行使することができる。',
  [k.TERMS_AND_CONDITIONS_38]: 'までメールを送信する。Eメールには以下の書式サンプルを使用することもできる：',
  [k.TERMS_AND_CONDITIONS_39]: '撤回フォームのサンプル',
  [k.TERMS_AND_CONDITIONS_40]: '- fidira Software UG (haftungsbeschränkt) 宛 E-mail: beeni@eurehochzeitonline.com：',
  [k.TERMS_AND_CONDITIONS_41]:
    '- 私/私たち( * )は、私/私たち( * )が締結したウェディングアプリ( * )のアクティベーション契約を撤回する。',
  [k.TERMS_AND_CONDITIONS_42]: '- 注文日( * ) / 受領日( * )',
  [k.TERMS_AND_CONDITIONS_43]: '- 消費者の氏名',
  [k.TERMS_AND_CONDITIONS_44]: '- 利用者の住所',
  [k.TERMS_AND_CONDITIONS_45]: '- 消費者の署名（紙で通知する場合のみ',
  [k.TERMS_AND_CONDITIONS_46]: '- 日付',
  [k.TERMS_AND_CONDITIONS_47]: '(*)適宜削除順序',
  [k.TERMS_AND_CONDITIONS_48]: '解約期間を遵守するためには、解約期間終了前に解約権行使の通知を送付すれば足りる：',
  [k.TERMS_AND_CONDITIONS_49]: '取り消しの結果:',
  [k.TERMS_AND_CONDITIONS_50]:
    '契約解除の結果：契約を解除した場合、当社は利用者のウエディングアプリを削除し、既に利用者から支払いを受けている場合は、同じ支払い方法にて利用者に返金する。この払い戻しにかかる費用は発生しない。',
  [k.TERMS_AND_CONDITIONS_51]:
    'ウェディングアプリのような物理的なデータキャリア上にないデジタルコンテンツの配信契約の場合、BGB第356条（5）に基づく取消権は、利用者が1.取消期間の満了前にサプライヤーが契約の履行を開始することに明示的に同意し、かつ2.契約の履行開始に同意することにより取消権を失うことを認識していることを確認した後にサプライヤーが契約の履行を開始した場合にも失効するものとする。',
  [k.TERMS_AND_CONDITIONS_52]: '§ 第7条 保証および免責条項',
  [k.TERMS_AND_CONDITIONS_53]:
    'プロバイダは、「現状有姿」、「すべての欠点を含む」、および「利用可能な状態」でサービスを提供し、商品性、特定目的への適合性、業務遂行性、非侵害、または法律で認められる範囲内のその他の保証について、明示または黙示の保証を行わない。また、プロバイダーのサービス（またはその一部、機能、コンテンツ）が完全であること、特定の品質であること、信頼できること、安全であること、正確であること、お客様の意図する活動、使用するデバイス、オペレーティングシステム、ブラウザ、または（ゲストまたはホストの）プログラムと互換性があること、お客様に適用される法的要件に準拠していること、またはサービスにウイルス、バグ、その他の有害なコンポーネントやプログラムの制限がないこと（または将来的にそうなること）を保証するものではない。さらに、EureHochzeitOnline.comは、EureHochzeitOnline.comプラットフォーム上で言及または提供されるいかなる企業、製品、サービス（第三者サービスを含む）についても責任を負わない。データおよび情報の損失に対していかなる責任も負わず、提供者はそのようなデータおよび情報の再構築を保証しない。利用者は自己の責任においてデータや情報をバックアップするものとする。また、EureHochzeitOnline.comは、利用者が投稿した内容や利用者の正確な身元について、いかなる責任も負わない。',
  [k.TERMS_AND_CONDITIONS_54]: '§ 第8条 分離条項',
  [k.TERMS_AND_CONDITIONS_55]:
    '本契約のいずれかの条項が、いかなる理由または程度であれ、無効または執行不能と判断された場合、かかる無効または執行不能は、本契約の残りの条項に影響を及ぼさず、かかる条項の適用は、法律で認められる最大限の範囲で執行されるものとする。EureHochzeitOnline.comが1つ以上の規約違反を執行する権利を放棄した場合、これはEureHochzeitOnline.comが他の規約を執行する権利も放棄したことを意味しない。',
  [k.TERMS_AND_CONDITIONS_56]: '§ 第 9 条 最終規定',
  [k.TERMS_AND_CONDITIONS_57]:
    '法律に別段の定めがない限り、本規約はドイツ連邦共和国法に準拠するものとする。本規約に起因または関連するすべての紛争/請求の専属的合意管轄地は、ミュンヘンとする。当社は、本利用規約を将来変更する権利を留保し、新しいバージョンを同じ場所に掲示する。利用規約の変更後、新バージョンを利用者が確認しなければならない。',
  [k.TERMS_AND_CONDITIONS_58]: 'ステータス01.04.2018',
  [k.IMPRINT_00]: 'インプリント/法的通知',
  [k.IMPRINT_01]: 'fidira Software UG (有限責任)',
  [k.IMPRINT_02]: 'EureHochzeitOnline.deはfidira Software UGの商標である。',
  [k.IMPRINT_03]: 'Enzianstr.31',
  [k.IMPRINT_04]: '86343 ケーニヒスブルン',
  [k.IMPRINT_05]: '電子メール',
  [k.IMPRINT_06]: 'ウェブ',
  [k.IMPRINT_07]: 'https://www.eurehochzeitonline.com',
  [k.IMPRINT_08]: '本社所在地ミュンヘン、ミュンヘン商業登記所HRB',
  [k.IMPRINT_09]: '代理人',
  [k.PRIVACY_00]: 'プライバシーポリシー',
  [k.PRIVACY_01]: 'はじめにと一般情報',
  [k.PRIVACY_02]:
    'お客様のプライバシーと結婚式のゲストのプライバシーの保護は、EureHochzeitOnline.comの最優先事項である。',
  [k.PRIVACY_03]:
    'ドイツ連邦データ保護法(BDSG)とドイツテレメディア法(TMG)の要求に従い、お客様のデータは、お客様個人のウェディングアプリの作成と使用、およびウェディングアプリのユーザーエクスペリエンスを最適化するためにのみ使用されることを常に保証する。当社は、ウェディングアプリの作成と使用の両方にTLS/SSL（トランスポート・レイヤー・セキュリティ/セキュア・ソケット・レイヤー）技術を使用しているため、データは送信中に常に暗号化される。当社のアプリケーションサーバーはすべて欧州連合にあり、EUデータプライバシー規制を遵守している。我々は、このプライバシーポリシーに記載されている目的を超えてあなたの情報を処理することはありません。登録プロセス中に、チェックボックスをクリックして、このプライバシーポリシーに記載されている処理への同意を求められる。同意することにより、あなたは当社が以下に記載された範囲であなたの個人データを収集、処理、使用することを確認する。同意はいつでも撤回することができる。その場合は、以下のカスタマーサービスまで電子メールをお送りください。',
  [k.PRIVACY_04]:
    '登録中に、プライバシー ポリシーに記載されている処理操作への同意を求められ、チェックボックスをクリックして同意します。 同意することにより、お客様は、当社が以下に記載されている範囲でお客様の個人データを収集、処理、および使用する場合があることを確認したものとみなされます。 また、いつでも同意を撤回することができます。 そのためには、カスタマー サービスに電子メールを送信してください。',
  [k.PRIVACY_05]:
    '.ご要望があれば、当社のカスタマーサービスは、お客様について保存されているすべてのデータに関する情報（ドイツ・テレメディア法（Telemediengesetz）第13条（7）に基づく）も提供し、お客様のご要望に応じてこれらのデータを削除する。',
  [k.PRIVACY_06]: '§ 第 1 条 責任主体および適用地域',
  [k.PRIVACY_07]:
    '責任主体は fidira Software UG (haftungsbeschränkt) であり、以下「プロバイダー」、「当社」または「EureHochzeitOnline.com」ともいう。住所および権限のある代表者についての詳細は、インプリントに記載されている。',
  [k.PRIVACY_08]:
    '本プライバシーポリシーは、インターネットブラウザを介して提供者のプラットフォームを訪問・利用する際の個人情報の収集と利用を対象とする。提供者は、これらのサービスを通じて、招待客が結婚式に関する情報を入手し、結婚式中に互いに交流できる（写真の共有や質問への回答など）個別の結婚式アプリを作成できるようにする。サプライヤーはまた、統計および市場分析の目的で個人データを使用する。その際、当社は、当社のサービスをさらに最適化するため、挙式、場所、挙式規模、アプリの使用状況などに関する匿名の統計を作成する。',
  [k.PRIVACY_09]: '§ 第 2 条 他のウェブサイトへのリンク',
  [k.PRIVACY_10]:
    '当社のウェブサイトには、他のウェブサイトへのリンクが含まれている場合がある。当社は、これらのリンクをクリックした後に誘導されるコンテンツや、第三者に送信される可能性のあるお客様のデータ処理（お客様のIPアドレスなど）については、一切管理していない。したがって、当社は、第三者のコンテンツおよび第三者による当該データの処理について、いかなる責任も負わない。',
  [k.PRIVACY_11]: '§ 第3条 登録を伴わないデータの使用',
  [k.PRIVACY_12]:
    'お客様がEureHochzeitOnline.comのウェブサイトまたはアプリにアクセスすると、当社はお客様のアクセスに関するいくつかの基本情報を自動的に保存する。これらの情報は、ユーザーの行動や頻繁に使用される機能に関する匿名の統計情報を作成し、当社のサービスを継続的に改善するために使用される。お客様のIPアドレスは、当社のシステムおよび当社が作成するウェディングアプリを悪用や詐欺から保護するために、限られた期間のみ技術ログファイルに保存される。',
  [k.PRIVACY_13]: '§ 第 4 条 登録時のデータの使用',
  [k.PRIVACY_14]:
    'ゲストとしてウェディングアプリにアクセスするため、またはホストとしてウェディングアプリを作成するために、ユーザーは登録しなければならない。登録プロセスでは、ユーザーの電子メールアドレス、表示名（自由に選択可能、偽名でも可）、ウェディングコード（該当する場合）、パスワード（自由に定義可能）が保存される。これらの情報は、ホストのウェディングリストを不正アクセスから保護するために使用される。結婚式アプリを作成する際、ホストはその結婚式のゲストにのみ公開される結婚式に関する情報（場所、時間、スケジュールなど）を入力することができる。これは、ゲストがウェディングアプリにアクセスするために入力しなければならないウェディングコードをホストが生成することによって達成される。',
  [k.PRIVACY_15]:
    '例えば、新規登録やその他の結婚式のニュースに関するEメール通知がホストに送信されたり、EureHochzeitOnline.comのサービスEメールがそのEメールアドレスに送信されたりする（満足度調査など）。また、結婚式のゲストのEメールアドレスをホストに表示し、ホストがさらなる結婚式の企画に利用できるようにする。',
  [k.PRIVACY_16]: 'お客様のメールアドレスが第三者や他の企業と共有されることは決してない。',
  [k.PRIVACY_17]: '§ 第5条 クッキー',
  [k.PRIVACY_18]:
    '最高のユーザーエクスペリエンスを提供するために、当社は「クッキー」と、いわゆる「ローカルストレージ」をブラウザに使用する。これにより、例えば、ブラウザを閉じたり、アプリ設定のフルスクリーンモードに切り替えたりしたときに変更が失われないように、または毎回ログインする必要がないように、ウェディングアプリに関する少量のデータをブラウザに保存することができる。クッキーを使用したくない場合、または既存のクッキーを削除したい場合は、ブラウザを通じてクッキーを無効化または削除できる。この方法については、ブラウザの説明を参照するか、当社までお問い合わせください。',
  [k.PRIVACY_19]:
    'また、より良いユーザー体験を提供するため、「§7 アプリケーションとウェブサイト」に記載されている以下の第三者サービスにもクッキーを使用している。',
  [k.PRIVACY_20]: '§ 6 アプリケーションとウェブサイト',
  [k.PRIVACY_21]: 'グーグルマップ',
  [k.PRIVACY_22]:
    '当社は、Google Inc（1600 Amphitheatre Parkway, Mountain View, CA 94043, USA）のGoogleマップを使用して、インタラクティブマップを表示している。お客様のIPアドレス、位置情報、および当社サービスの利用に関する情報は、米国内のサーバーに送信され、Googleによって保存される。グーグルマップの利用規約は',
  [k.PRIVACY_23]: 'https://www.google.com/intl/de_de/help/terms_maps.html',
  [k.PRIVACY_24]: 'HotJar',
  [k.PRIVACY_25]:
    '当社はまた、Hotjar Ltd.のウェブ分析ツールであるHotJarを使用し、マーケティングおよび最適化の目的でデータを収集・保存している。このデータは、偽名のユーザープロファイルを作成するために使用することができる。ランダムに選択された個々の訪問（追加の個人情報を含まない、いわゆる「ユーザー属性」）が記録される。収集されたデータは、本ウェブサイトの訪問者を個人的に特定するために使用されることはなく、また、関係者の個別の同意なしに、ペンネームの持ち主に関する個人データと統合されることもない。追跡を希望しない場合は、以下のリンクをクリックすることで、現在使用しているブラウザのHotJarを使用するすべてのウェブサイトで追跡をグローバルに無効にすることができる。',
  [k.PRIVACY_26]: 'https://www.hotjar.com/privacy/do-not-track/',
  [k.PRIVACY_27]: 'メールチンプ',
  [k.PRIVACY_28]:
    'ニュースレターの配信には、The Rocket Science Group, LLC, 675 Ponce de Leon Ave NE Suite 5000, Atlanta, GA 30308 USA (Mailchimp)のMailchimpを使用している。これにより、購読者に直接連絡することができる。さらに、私たちは私たちの提供を最適化するためにあなたの使用行動を分析する。',
  [k.PRIVACY_29]: 'この目的のため、以下の個人情報をMailchimpと共有する。',
  [k.PRIVACY_30]: 'メールアドレス [名] [挙式日] [挙式情報] [ログイン詳細]。',
  [k.PRIVACY_31]:
    '当社のEメールには、個人情報を更新するためのリンクが含まれる。Mailchimpはお客様の個人情報の受領者であり、当社のニュースレターの配信に関する限り、当社に代わって処理者として機能する。このセクションに記載されているデータの処理は、法律や契約によって義務付けられているものではない。お客様の同意と個人データの提出がなければ、ニュースレターをお送りすることはできない。また、Mailchimpは、クッキーやその他のトラッキング方法を使用して、以下の個人情報を収集する。 お客様のデバイスに関する情報（IPアドレス、デバイス情報、オペレーティングシステム、ブラウザID、お客様がメールを読むために使用しているアプリケーションに関する情報、その他ハードウェアやインターネット接続に関する情報。さらに、お客様がメール/キャンペーンを開いた日時やブラウザのアクティビティ（どのメール/ウェブサイトを開いたかなど）などの利用データも収集される。Mailchimpは、システムのセキュリティと信頼性を確保し、利用規約を実施し、悪用を防止するためにこれらの情報を必要とする。これはMailchimpの正当な利益（GDPR第6条第1項fに基づく）に相当し、契約の履行に役立つ（GDPR第6条第1項bに基づく）。Mailchimpは、メール配信統計やその他の通信データなどのパフォーマンスデータも分析する。これらの情報は、本サービスの利用統計およびパフォーマンス統計の作成に使用される。Mailchimpはまた、他の情報源からお客様に関する情報を収集する。ソーシャルメディアやその他の第三者データプロバイダーを通じて、不定期に個人情報が収集されることがある。当社はこれらのプロセスを管理することはできない。',
  [k.PRIVACY_32]: 'Mailchimpにおけるお客様の選択肢と削除オプションの詳細については、以下を参照のこと。',
  [k.PRIVACY_33]: 'https://mailchimp.com/legal/privacy/#3._Privacy_for_Contacts',
  [k.PRIVACY_34]:
    'この処理の法的根拠は、GDPR第6条第1項aに従ったお客様の同意である。お客様は、個人情報の処理に対する同意をいつでも撤回することができる。そのためのリンクはすべてのメールに記載されている。同意を撤回しても、すでに行われた処理の合法性には影響しない。',
  [k.PRIVACY_35]:
    'あなたの同意がある限り、あなたのデータは処理される。それ以外の場合は、法的要件によりさらなる保存が必要な場合を除き、当社とMailchimpの間の契約が終了した後に削除される。',
  [k.PRIVACY_36]:
    'Mailchimpは国際的なデータ転送のためのコンプライアンス対策を実施している。これらの対策は、MailchimpがEU内の個人の個人データを処理するすべてのグローバルオペレーションに適用される。これらの方針は、EU標準契約条項（SCCs）に基づいている。詳細は以下を参照のこと。',
  [k.PRIVACY_37]: 'https://mailchimp.com/legal/data-processing-addendum/',
  [k.PRIVACY_38]: 'スポティファイ',
  [k.PRIVACY_39]:
    '当社はまた、Spotify ABの音楽プレーヤーであるSpotify Music Player Widgetを使用して、結婚式のプレイリストを聴けるようにしている。Spotify Music Player Widgetのサービスプロバイダーは、Spotify AB, Regeringsgatan 19, 111 53 Stockholm, Swedenである。Spotify ABのデータ処理に関する詳細は、以下を参照のこと。',
  [k.PRIVACY_40]: 'https://www.spotify.com/de/legal/privacy-policy/',
  [k.PRIVACY_41]: 'フェイスブックピクセル',
  [k.PRIVACY_42]:
    'EureHochzeitOnline.comを改善し、より多くのユーザーに知ってもらうために、Facebook Inc, 1601 South California Avenue, Palo Alto, CA 94304, USA（以下「Facebook」）のFacebook Pixelを使用している。このために、Facebookはあなたのブラウザにクッキーを置く。このクッキーによって生成された、当ウェブサイトの利用状況に関する情報は、米国内のサーバーに転送され、フェイスブックによって保存される。フェイスブックはこのデータ転送を利用して、特定のページがあなたのブラウザからアクセスされたこと、およびそれが広告のクリックによって行われたかどうかを判断することができる。しかし、私たちはこのデータを私たちのサイトからの情報を収集するために使用しない。フェイスブックはこの情報を追加広告の作成とEureHochzeitOnline.comの宣伝のために使用する。弊社はEureHochzeitOnline.comをさらに改善するため、Facebookピクセルから得たデータをFacebookの分析ツール「Facebook Analytics」で評価する。フェイスブックは、法律で義務付けられている場合、またはそのような第三者がフェイスブックに代わって情報を処理する場合、この情報を第三者に転送することがある。EureHochzeitOnline.comを利用することにより、利用者はFacebookがEureHochzeitOnline.comを改善する目的で、記載された方法で利用者に関するデータを処理することに同意するものとする。我々は、あなたの個人情報、連絡先、結婚式の情報をFacebookと共有することはない。Facebookピクセルのセキュリティおよびプライバシーポリシーについては、以下を参照のこと。',
  [k.PRIVACY_43]: 'https://www.facebook.com/policy.php',
  [k.PRIVACY_44]: 'ここをクリックすることで、Facebook Pixelによる情報収集をオプトアウトすることもできる：',
  [k.PRIVACY_45]: 'ピクセルを無効にする',
  [k.PRIVACY_46]: '§ 第7条 BDSGに従った情報への権利およびその他の権利',
  [k.PRIVACY_47]:
    '当社は、当社が保管するお客様の個人データに関する情報を、いつでも喜んで提供する。また、お客様のご要望に応じて、お客様のデータを修正、ブロックまたは削除する。このようなご要望、または取り消しの宣言については、いつでも下記までご連絡ください。',
  [k.PRIVACY_48]: 'にご連絡いただければ、可能な限り速やかに変更する。',
  [k.PRIVACY_49]: '§ 第8条 データ保護宣言の変更',
  [k.PRIVACY_50]:
    'インターネットおよび技術的可能性は常に発展している。そのため、個人情報保護方針を更新し、修正することがある。',
  [k.PRIVACY_51]: '最終更新日11/28/2022',
  [k.IF_YOU_NEED_MORE_LANGUAGES]: 'さらに多くの言語が必要な場合は、電子メールでお問い合わせください。',
  [k.DECIDE_LANGUAGES]:
    '結婚式の Web サイトがどの言語をサポートするかを決定します。 選択したすべての言語のテキストを入力できます。',
  [k.EDIT_LANGUAGES]: `言語の編集`,
  [k.ACTIVE_VOUCHER]: `アクティブなバウチャー:`,
  [k.ENTER_VOUCHER_CODE]: `クーポンコードを入力してください`,
  [k.VOUCHER_CODE]: `ディスカウントコード`,
  [k.INVALID_CODE]: `残念ながら有効なコードではありません!`,
  [k.WANT_CUSTOM_LOGO]: `ご自身の結婚式のロゴを使用されたいですか？`,
  [k.INDIVIDUAL_LOGO]: `カスタムロゴ`,
  [k.STANDARD_LOGO]: `標準ロゴ`,
  [k.PRIVATE_PURCHASE]: `購入は個人取引です`,
  [k.COMMERCIAL_PURCHASE]: `購入は商用です`,
  [k.MAX_GUESTS]: '無料版：ゲストの最大数',
  [k.MAX_GUESTS_REACHED]:
    'この結婚式は現在も EureHochzeitOnline.com の無料基本バージョンを使用していますが、登録ゲスト数が5人を超えました。利用規約により、コンプリートまたはプレミアムパッケージへのアップグレードが必要です。引き続き結婚式のウェブサイトを通常通りご利用いただくために、パッケージをアップグレードしてください。',
  [k.ACTIVATE_PACKAGE]: 'パッケージを解除する',
  [k.IF_MESSAGE_WRONGFUL]:
    'このメッセージが誤って表示されていると思われる場合は、次のメールアドレスまでご連絡ください:',
  [k.DOMAIN_SEARCH_TITLE]: '結婚式のためのドメイン検索',
  [k.DOMAIN_SEARCH_DESCRIPTION]:
    '結婚式のホームページがアクセス可能になるアドレスを入力してください。登録を行い、リダイレクトを設定します。',
  [k.DOMAIN_SEARCH_LABEL]: '希望のアドレス',
  [k.DOMAIN_AVAILABLE_TITLE]: '❤️ ドメインが利用可能です！ ❤️',
  [k.DOMAIN_AVAILABLE_DESCRIPTION]: 'は利用可能です - 今すぐ予約できます。ドメインとリダイレクトを自動的に設定します。',
  [k.DOMAIN_NOT_AVAILABLE]: '残念ながら、ドメインは利用できません。これらを試すことができます。',
  [k.DOMAIN_SUGGESTIONS]: 'ドメインの提案:',
  [k.DOMAIN_CHECK_AVAILABILITY]: '利用可能性を確認する',
  [k.DOMAIN_BOOK]: '予約する',
  [k.DOMAIN_BACK]: '戻る',
  [k.DOMAIN_CONFIRM_TITLE]: '本当によろしいですか？',
  [k.DOMAIN_CONFIRM_DESCRIPTION]:
    '今確認すると、ドメインを自動的に予約します。このステップは元に戻せません。ドメインにタイプミスや類似のエラーがないことを確認してください。予約するにはOKをクリックしてください。',
  [k.DOMAIN_REGISTRATION_SUCCESS_TITLE]: '登録が委託されました',
  [k.DOMAIN_REGISTRATION_SUCCESS_DESCRIPTION]:
    'ドメイン登録が正常に開始されました。バックグラウンドで全てを処理します - これには最大48時間かかる場合があります。完了後、メールでお知らせします。',
  [k.BASISDATEN]: '基本データ',
  [k.DESIGN]: 'デザイン',
  [k.YOUR_OWN_DOMAIN]: 'あなたたちのドメイン',
  [k.DOMAIN_REACHABLE]:
    'あなたたちの結婚式ページはここでアクセスできます。設定には最大48時間かかることがあります。もしそれ以降もうまくいかない場合はご連絡ください: ',
  [k.PREMIUM_PACKAGE_DOMAIN]: 'プレミアムパッケージをお持ちで、ドメインを登録できます。',
  [k.CLICK_HERE]: 'ここをクリック！',
  [k.UPGRADE_TO_PREMIUM]:
    '独自ドメインを使用するには、プレミアムパッケージにアップグレードする必要があります。ご連絡ください: ',
  [k.REGISTER_DOMAIN_AFTER_PREMIUM]: 'プレミアムパッケージを有効化した後で独自ドメインを登録してください。',
};
